<template>
  <!-- <div class="white pa-0" > -->
    <!-- <v-row class="text-center px-0"> -->

      <v-col class="white lighten-5 mb-10 py-0" cols="12">
        <v-col
          class="white lighten-5 mb-5 py-0 col-md-10 offset-md-1 col-12 offset-0"
        >
          <!-- class="white lighten-5 mb-5 py-0 col-md-10 offset-md-1 col-12 offset-0" -->
          <div class="white lighten-5" style="height: 70px"></div>
          <h2
            class="white lighten-5 headline font-weight-bold mb-3 other-element"
            style="letter-spacing: 0.13125em !important; color: #616161"
          >
            НАШИ ПИТОМЦЫ
          </h2>
          <v-divider
            class="grey darken-2 mx-auto"
            light
            style="min-height: 3px; max-width: 50px"
          ></v-divider>
          <!-- <transition name="fade"> -->
          <v-row justify="center">
            <v-col
              v-for="(item, k) in dogs"
              :key="k"
              data-aos="fade-up"
              data-aos-offset="100"
              data-aos-delay="1"
              data-aos-duration="1500"
              data-aos-easing="ease-out-back"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-anchor-placement="top-center"
              data-aos-anchor=".other-element"
              class=" col-sm-4 offset-sm-1 col-md-3 offset-md-0 col-12"
            >
              <v-card
                flat
                class="white lighten-5 pa-3 mt-3"
                height="250"
                :to="{ name: 'pets', params: { id: item.id } }"
              >
                <v-sheet light>
                  <v-card-text class="white lighten-5">
                    <v-row justify="center">
                      <v-hover v-slot="{ hover }">
                        <v-avatar size="16em" class="d-inline-flex border-style">
                          <v-img class="pa-0 ma-0" dark :src="item.image"></v-img>
                          <v-expand-transition>
                            <div
                              v-if="hover"
                              class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal display-1 white--text"
                              style="height: 100%; opacity: 75%"
                            >
                              {{ item.nickname }}
                            </div>
                          </v-expand-transition>
                        </v-avatar>
                      </v-hover>
                    </v-row>
                    <v-row justify="center" class="hidden-md-and-up">
                      <v-card-title class="body-1 text--darken-1 text-center">
                        <div class="textMainPage textWordBreak">
                          {{ item.nickname }}
                        </div>
                      </v-card-title>
                    </v-row>
                  </v-card-text>
                </v-sheet>
              </v-card>
              <!-- </div> -->
            </v-col>
          </v-row>
          <v-row justify="center">
            <div class="justify-center align-center text-center mb-5 mt-16">
              <v-btn
                class="btnStyle"
                rounded
                color="orange"
                dark
                large
                elevation="6"
                @click="goTo('dogs')"
                data-aos="fade-up"
                data-aos-offset="100"
                data-aos-delay="10"
                data-aos-duration="1500"
                data-aos-easing="ease-out-back"
                data-aos-once="false"
                data-aos-anchor-placement="top-bottom"
              >
                <v-icon class="ml-2 mr-5 brown--text" size="35"
                  >mdi mdi-dog</v-icon
                >ПЕРЕЙТИ<v-icon class="ml-5 mr-2 brown--text" size="35"
                  >mdi mdi-cat</v-icon
                >
              </v-btn>
            </div>
          </v-row>
          <!-- <div class="white lighten-5" style="height: 70px"></div> -->
        </v-col>
      </v-col>

    <!-- </v-row> -->


  <!-- </div> -->
</template>



<script>
export default {
  name: "SectionThree",
  
    computed: {
    dogs() {
      return this.$store.getters.getDogsMainPage;
    },
  },

  methods: {
    goTo(value) {
      this.$router.push(value).catch(() => {});
    },
  },



};
</script>

<style scoped>

.border-style {
  border: 6px solid #ECEFF1;
}
 
</style>

